







































































































import { Component, Vue } from "vue-property-decorator";
import { Term } from "@/interfaces";

import { TermsManagementModule } from "@/store";
import { notifyError, notifySuccess } from "@/common/notify";
import NewTermDialog from "@/components/NewTermDialog.vue";

@Component
export default class TermsManagement extends Vue {
  @TermsManagementModule.bindings.State
  terms!: Term[];

  @TermsManagementModule.bindings.State
  loading!: boolean;

  filteredData: Term[] = [];

  searchText = "";

  async mounted() {
    try {
      await TermsManagementModule.store.search();
      this.filteredData = this.terms;
    } catch (error) {
      console.log(error);
    }
  }

  dataSearchSubmit() {
    if (this.searchText.trim() !== "") {
      this.filteredData = this.terms.filter(term => term.title.toLowerCase().includes(this.searchText.toLowerCase()));
    } else {
      this.filteredData = this.terms;
    }
  }

  onDeleteTerm(term: Term) {
    this.$q
      .dialog({
        title: "Attenzione",
        message: `Sei sicuro di volere eliminare il termine <strong>${term.title}</strong>?`,
        html: true,
        cancel: true,
      })
      .onOk(() => {
        this.deleteTermAction(term);
      });
  }

  openAddDialog() {
    this.$q
      .dialog({
        component: NewTermDialog,
        parent: this,
        title: "Crea Termine",
      })
      .onOk(() => {
        this.filteredData = this.terms;
        this.searchText = "";
      });
  }

  openEditDialog(term: Term) {
    this.$q
      .dialog({
        component: NewTermDialog,
        parent: this,
        title: "Modifica Termine",
        term,
      })
      .onOk(() => {
        this.filteredData = this.terms;
        this.searchText = "";
      });
  }

  async deleteTermAction(term: Term) {
    try {
      await TermsManagementModule.store.deleteTerm(term.id);
      this.filteredData = this.terms;
      this.searchText = "";
      notifySuccess("Termine rimosso con successo!");
    } catch (error) {
      console.log(error);
      notifyError("Errore imprevisto, non è stato possibile eliminare il termine!");
    }
  }

  get columns() {
    return [
      {
        name: "title",
        label: "Titolo",
        field: "title",
        align: "left",
        sortable: true,
      },
      { name: "edit", align: "center" },
      { name: "delete", align: "center" },
    ];
  }
}
